module.exports = __webpack_public_path__ + "static/media/zgoda_na_przetwarzanie_danych_osobowych.8cbf8c49.pdf";